export default __webpack_public_path__ + "static/media/results6.9d8b216c.png";